// extracted by mini-css-extract-plugin
export var bordertop = "text-element-module--bordertop--66120";
export var uppercasetext = "text-element-module--uppercasetext--01d9d";